import { render } from "./ClubsSection.vue?vue&type=template&id=d2d07962&scoped=true"
import script from "./ClubsSection.vue?vue&type=script&lang=js"
export * from "./ClubsSection.vue?vue&type=script&lang=js"

import "./ClubsSection.vue?vue&type=style&index=0&id=d2d07962&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2d07962"]])

export default __exports__